import { setMetaDescription, setMetaImage, setMetaOgTitle, setMetaOgDescription } from 'utils';
import axios from 'axios';
const getCityFromCoordinates = async (lat, lng) => {
  try {
    const response = await axios.get(`https://nominatim.openstreetmap.org/reverse`, {
      params: {
        lat,
        lon: lng,
        format: 'json'
      }
    });
    const city = response.data.address.city || response.data.address.town || response.data.address.village;
    alert(city);
    return city;
  } catch (err) {

    console.error(err);
  }
};
const ProfileMetaHook = (Component) => (props) => {
  const setMeta = (barber) => {
    const metaDescription = generateMetaDescriptionFromProfile(barber);
    console.log(metaDescription);
    const name = barber.display_name || barber.name || "Your Barber";
    console.log(barber.addresses?.[0]?.coordinates);


    const city = barber.addresses?.[0]?.city || barber.addresses?.[1]?.city || barber.addresses?.[0]?.name || barber.addresses?.[1]?.name || "your city";
    console.log(barber)
    const reviewCount = barber.number_reviews || 0;
    document.title = `${name} - ${city} Barber - Book Online | Barbr`;
    setMetaOgTitle(`${name} - ${city} Barber - Book Online | Barbr`);
    document.querySelector('meta[name="description"]').setAttribute('content', metaDescription);

    setMetaDescription(metaDescription);
    setMetaImage(barber.image);
    setMetaOgDescription(`Book your next haircut with ${name} in ${city}. Trusted barber with ${reviewCount}+ reviews. Book in seconds with Barbr`);

    // Set Instagram URL meta tag if it exists
    if (barber.instagram_url) {



      const instagramTag = document.querySelector('meta[property="og:see_also"]') || document.createElement('meta');
      instagramTag.setAttribute('property', 'og:see_also');
      instagramTag.setAttribute('content', barber.instagram_url || 'https://www.instagram.com/getbarbr');
      if (!document.querySelector('meta[property="og:see_also"]')) {
        document.head.appendChild(instagramTag);
      }
    }
    const keywords = generateBarberKeywords(barber);
    console.log(keywords);

    // Set keywords meta tag
    const keywordsTag = document.querySelector('meta[name="keywords"]') || document.createElement('meta');
    keywordsTag.setAttribute('name', 'keywords');
    keywordsTag.setAttribute('content', keywords);
    if (!document.querySelector('meta[name="keywords"]')) {
      document.head.appendChild(keywordsTag);
    }

    // Inject or update JSON-LD script for HairSalon schema
    const existingJsonLd = document.querySelector('script[type="application/ld+json"][data-barbr-schema="hairsalon"]');
    if (existingJsonLd) {
      existingJsonLd.remove();
    }
    const jsonLdScript = document.createElement('script');
    jsonLdScript.type = 'application/ld+json';
    jsonLdScript.setAttribute('data-barbr-schema', 'hairsalon');
    jsonLdScript.text = generateBarberJsonLd(barber);
    document.head.appendChild(jsonLdScript);
  };

  return <Component {...props} updateMeta={setMeta} />;
};


// Assume `data` is your JSON object from the file

function generateMetaDescriptionFromProfile(data) {
  // Get display name
  const displayName = data.display_name || "Your Barber";

  // Get city from addresses
  const city = data.addresses?.[0]?.city || data.addresses?.[1]?.city || data.addresses?.[0]?.name || data.addresses?.[1]?.name || "your city";

  // Build the meta description
  return `Book your next haircut or beard trim with ${displayName}, a trusted barber in ${city}. View prices, services, and real reviews. Book in seconds with Barbr.`;
}

// Example usage:
function generateBarberKeywords(profile) {
  // 1. Barber Name Variations
  const name = profile.display_name ? profile.display_name.trim() : '';
  const nameKeywords = name ? [name, `Barber ${name}`] : [];

  // 2. Service Names (filtering out test/dummy/xyz/ok/123)
  const badWords = /test|dummy|xyz|ok|123/i;
  const serviceKeywords = Array.from(
    new Set(
      (profile.services || [])
        .map(s => s.name && s.name.trim())
        .filter(name => name && !badWords.test(name))
        .map(name => name.toLowerCase())
    )
  );

  // 3. Service Types
  let typeKeywords = [];
  if (profile.is_shop) typeKeywords.push('shop barber');
  if (profile.is_mobile) typeKeywords.push('mobile barber', 'home service barber');

  // 4. Locations (from addresses)
  const locationKeywords = Array.from(
    new Set(
      (profile.addresses || [])
        .map(addr => addr.name && addr.name.trim())
        .filter(Boolean)
    )
  );

  // 5. General/Popular Keywords
  const generalKeywords = [
    "men's haircut", "professional barber", "affordable barber", "best barber", "barber near me", "book barber online"
  ];

  // 6. Combine and Deduplicate
  const allKeywords = Array.from(new Set([
    ...nameKeywords,
    ...serviceKeywords,
    ...typeKeywords,
    ...locationKeywords,
    ...generalKeywords
  ]));

  // 7. Return as comma-separated string (max 255 chars for SEO)
  return allKeywords.join(', ').slice(0, 255);
}

// Example usage:

function generateBarberJsonLd(barber) {
  const name = barber.display_name || barber.name || "Your Barber";
  const image = barber.image || "";
  const url = barber.profile_url || window.location.href;
  const address = {
    "@type": "PostalAddress",
    "addressLocality": barber.addresses?.[0]?.name || "your city",
    "addressCountry": barber.addresses?.[0]?.country || "your country"
  };
  const aggregateRating = barber.rating
    ? {
      "@type": "AggregateRating",
      "ratingValue": barber.rating.toString() || 0,
      "reviewCount": (barber.number_reviews || 0).toString()
    }
    : undefined;
  const priceRange = barber.price_range || "";
  const telephone = barber.phone || "";

  const jsonLd = {
    "@context": "https://schema.org",
    "@type": "HairSalon",
    name,
    image,
    url,
    address,
    ...(aggregateRating && { aggregateRating }),
    ...(priceRange && { priceRange }),
    ...(telephone && { telephone })
  };

  return JSON.stringify(jsonLd, null, 2);
}

export default ProfileMetaHook;
